export const groupVisitRecords = [
  { date: "2025.09.10", region: "화성시", institutions: ["창의나라어린이집"], attendees: 54, images: [1, 2] },
  { date: "2025.12.16", region: "수원시", institutions: ["블루밍어린이집"], attendees: 34, images: [5] },
  { date: "2025.12.17", region: "평택시", institutions: ["시립이편한세상지제역어린이집"], attendees: 61, images: [6, 7] },
  { date: "2025.12.18", region: "수원시", institutions: ["온사랑어린이집"], attendees: 46, images: [8] },
  { date: "2025.12.23", region: "평택시", institutions: ["시립지제역자이어린이집"], attendees: 66, images: [9, 10, 11, 12] },
  { date: "2026.01.08", region: "오산시", institutions: ["시립중흥에듀파크어린이집"], attendees: 68, images: [13] },
  { date: "2026.01.09", region: "용인시", institutions: ["모현어린이집"], attendees: 50, images: [14, 15, 16, 17, 18, 19, 20] },
  { date: "2026.01.13–16", region: "광주시", institutions: ["세연어린이집"], attendees: 188, images: [21, 22, 23, 24, 25, 26], note: "4일간 진행" },
  { date: "2026.01.22", region: "수원시", institutions: ["시립영통트레센츠어린이집", "시립영통파인베르어린이집"], attendees: 60, images: [27, 28, 29], note: "두 기관 공동관람" },
  { date: "2026.01.30", region: "수원시", institutions: ["시립롯데캐슬엘클래스1어린이집"], attendees: 42, images: [30] },
  { date: "2026.02.03", region: "화성시", institutions: ["아해뜰어린이집"], attendees: 52, images: [31, 32, 33] },
  { date: "2026.02.05", region: "화성시", institutions: ["아해뜰어린이집"], attendees: 61, images: [34, 35] },
  { date: "2026.02.10", region: "용인시", institutions: ["양지어린이집"], attendees: 49, images: [36, 37, 38, 39, 40, 41, 42] },
  { date: "2026.02.23", region: "수원시", institutions: ["블루밍어린이집"], attendees: 29, images: [43] },
  { date: "2026.03.26", region: "오산시", institutions: ["시립롯데캐슬어린이집"], attendees: 76, images: [44] },
  { date: "2026.04.24", region: "안성시", institutions: ["아이생각어린이집"], attendees: 42, images: [45] },
  { date: "2026.06.09", region: "화성시", institutions: ["향남아이비어린이집"], attendees: 52, images: [46] },
  { date: "2026.06.17", region: "평택시", institutions: ["시립뉴비전엘크루어린이집"], attendees: 40, images: [3, 4] },
];

export const familyEventPhotos = [
  { date: "2025.12.11", image: 47 }, { date: "2025.12.11", image: 48 }, { date: "2025.12.11", image: 49 },
  { date: "2025.12.25", image: 50 }, { date: "2025.12.25", image: 51 }, { date: "2026.02.07", image: 52 }, { date: "2026.03.01", image: 53 },
];

export const groupVisitImage = (index) => index === 45
  ? "/images/group-visits/45-phone-blurred.webp"
  : `/images/group-visits/${String(index).padStart(2, "0")}.webp`;
